const verloopModal = {
	/**
	 * Opens the verloop arbeidsongeschiktheid modal
	 *
	 * @returns {void}
	 */
	init: function () {
		if (document.querySelector('[data-link-verloop-arbeidsongeschiktheid]')) {
			document.querySelector('[data-link-verloop-arbeidsongeschiktheid]').click();
		}
	},
};

export default verloopModal;
